import styled, { css } from 'styled-components';
import type { FontWeightName, HeadingLevel } from '@makemydeal/dr-ui-bricks-types';
import { headingFontStyles } from '../typographyScale/fontStyles';

// theme.uiBricks is a flat token map (or undefined outside sales-checkin); cast inline at use site.
export const StyledHeading = styled.h1<{ $level: HeadingLevel; $weight: FontWeightName; $color?: string }>`
    margin: 0;
    ${({ $level, $weight }) => headingFontStyles($level, $weight)}
    ${({ theme, $color }) => {
        const color = $color ?? (theme as { uiBricks?: Record<string, string> }).uiBricks?.headlineFontColor;
        return (
            color &&
            css`
                color: ${color};
            `
        );
    }}
`;
